import forEach from '../../../../javascripts/dom/forEach';

const mainNavigations = document.querySelectorAll('[data-js-module="m-main-navigation"]');

export default function init() {
  const initMainNavigation = async () => {
    const { default: MainNavigation } = await import(
      /* webpackChunkName: "m-main-navigation" */
      './main-navigation'
    );
    forEach(mainNavigations, (index, element) => new MainNavigation(element));
  };

  if (mainNavigations.length) {
    initMainNavigation();
  }
}

if (mainNavigations.length) init();
